// slices/voucherTypeFinanceMasterSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface VoucherTypeFinanceMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allVoucherTypeFinanceMasterList: any[];
}

const initialState: VoucherTypeFinanceMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allVoucherTypeFinanceMasterList: [],
};

export const voucherTypeFinanceMasterSlice = createSlice({
  name: 'voucherTypeFinanceMaster',
  initialState,
  reducers: {
    setVoucherTypeFinanceMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherTypeFinanceMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllVoucherTypeFinanceMaster: (state, action) => {
      state.allVoucherTypeFinanceMasterList = action.payload.data;
    },
    resetVoucherTypeFinanceMaster: () => initialState,
  },
});

export const {
  setVoucherTypeFinanceMaster,
  setVoucherTypeFinanceMasterBySearch,
  setAllVoucherTypeFinanceMaster,
  resetVoucherTypeFinanceMaster,
} = voucherTypeFinanceMasterSlice.actions;

export const getVoucherTypeFinanceMasterData = (state: RootState) => state.voucherTypeFinanceMaster.data;
export const getVoucherTypeFinanceMasterList = (state: RootState) => state.voucherTypeFinanceMaster.allVoucherTypeFinanceMasterList;
export const getVoucherTypeMasterListWithAll = (state: RootState) => [
  {
    id: 0,
    name: "All",
    description: "All Voucher Type",
    isActive: true,
  },
  ...(state.voucherTypeFinanceMaster.allVoucherTypeFinanceMasterList || []),
];
export const getVoucherTypeFinanceMasterTotalRecords = (state: RootState) => state.voucherTypeFinanceMaster.totalRecords;
export const getVoucherTypeFinanceMasterBySearch = (state: RootState) => state.voucherTypeFinanceMaster.data;
export default voucherTypeFinanceMasterSlice.reducer;
